import { useSearchParams } from "react-router-dom";
import PageHero from "@/components/PageHero";
import LeadForm from "@/components/LeadForm";
import { FadeIn, MaskedLines, Chapter } from "@/components/Motion";
import { LEAD_TYPES } from "@/data/content";

const VALID = new Set(LEAD_TYPES.map((t) => t.value));

const INFO = [
  { label: "Business Development", value: "info@active-stairlifts.com" },
  { label: "Distributor Enquiries", value: "info@active-stairlifts.com" },
  { label: "OEM / ODM Projects", value: "info@active-stairlifts.com" },
  { label: "Response Time", value: "Within 48 hours, guaranteed" },
];

export default function Contact() {
  const [params] = useSearchParams();
  const type = params.get("type");
  const defaultType = VALID.has(type) ? type : "distributor";

  return (
    <>
      <PageHero
        overline="Contact"
        lines={["Let's build", "your stairlift business"]}
        sub="Distributor applications, OEM manufacturing projects, ODM development, sales, technical and support — one form, routed to the right team."
      />

      <section className="bg-white pb-24 sm:pb-32" data-testid="contact-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Chapter index="01" label="Direct Lines" />
            <div className="space-y-0">
              {INFO.map((row, i) => (
                <FadeIn key={row.label} delay={i * 0.06}>
                  <div className="py-5 border-b border-slate-200/80 first:border-t" data-testid={`contact-info-${i}`}>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">{row.label}</p>
                    <p className="mt-1.5 font-display text-lg font-medium tracking-tight text-slate-950">{row.value}</p>
                  </div>
                </FadeIn>
              ))}
            </div>
            <FadeIn delay={0.25}>
              <div className="mt-8 rounded-2xl bg-obsidian noise-dark border border-white/10 p-8">
                <p className="relative z-[2] font-mono text-[10px] uppercase tracking-[0.25em] text-signal">Headquarters</p>
                <p className="relative z-[2] mt-3 font-display text-lg font-medium text-white">ACTIVE Stairlifts</p>
                <p className="relative z-[2] mt-1 text-sm text-slate-400 leading-relaxed">
                  Via Isaac Newton 9A<br />20016 Pero MI · Italy
                </p>
              </div>
            </FadeIn>
          </div>
          <div className="lg:col-span-7">
            <FadeIn delay={0.15}>
              <div className="rounded-2xl border border-slate-200/80 bg-white p-7 sm:p-10">
                <h2 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-slate-950 mb-7">
                  <MaskedLines immediate lines={["Send your request"]} />
                </h2>
                <LeadForm key={defaultType} defaultType={defaultType} showTypeSelect context="Contact page" />
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </>
  );
}
